export const ADD_NEW_PRODUCT_TO_CART = "ADD_NEW_PRODUCT_TO_CART";
export const DELETE_PRODUCT_FROM_CART = "DELETE_PRODUCT_FROM_CART";
export const INCREASE_PRODUCT_AMOUNT = "INCREASE_PRODUCT_AMOUNT";
export const DECREASE_PRODUCT_AMOUNT = "DECREASE_PRODUCT_AMOUNT";
export const EDIT_PRODUCT_SIZE = "EDIT_PRODUCT_SIZE";
export const SELECT_PAGE = "SELECT_PAGE";






